import * as React from "react";
import { Box, Typography, useTheme, Grid, InputBase} from "@mui/material";
import {useEffect, useState} from 'react';
import axios from 'axios';
import {API_ENDPOINT_URL} from "../../util/api";
import { getLocalItem } from "../../util/helper";
import DragDropFile from "../../components/DragDrop";
import TableImportData from "../../components/TableImportData";

const timezone = 'Asia/Tokyo';

const columns = [
    {
      field: "file_name",
      headerName: "File Name",
      flex: 1,
      cellClassName: "name-column--cell"
    },
    {
      field: "created",
      headerName: "Created",
      flex: 1,
      cellClassName: "name-column--cell"
    },
    {
      field: "download",
      headerName: "Download",
      flex: 1
    },
  ];


const FileImport = () => {
  const [loadingTable, setLoadingTable]= useState(false)
  const token = getLocalItem("key")

  const [fileListData, setFileListData] = useState([]);

  const getFileUploadData = async () => {
    setLoadingTable(true)
    try {
      const response = await axios.get(`${API_ENDPOINT_URL}/file/upload/`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setFileListData(response.data);
      setLoadingTable(false)
    } catch (error) {
      setLoadingTable(false)
    }
  };

  useEffect(() => {
    getFileUploadData();
  }, []);

  const handleImportFile = (formData) => {
    axios
      .post(`${API_ENDPOINT_URL}/file/upload/`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${token}`,
        },
      })
      .then((response) => {
        // Handle the API response
        getFileUploadData()
      })
      .catch((error) => {
        // Handle any errors
        console.error(error);
      });
  };

  const handleDownload = (row) => {
    axios
      .get(`${API_ENDPOINT_URL}/files/download/`, {
        params: { file_name: row.file_name, created: row.created },
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: 'blob',
      })
      .then((response) => {
        // Handle the API response
        const downloadUrl = window.URL.createObjectURL(new Blob([response.data], { type: 'text/tab-separated-values' }));  // Specify the response type as TSV
        const link = document.createElement('a');
        link.href = downloadUrl;
        // Replace the file extension
        const tsvFileName = row.file_name.replace('.txt', '.tsv');
        link.setAttribute('download', tsvFileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
      })
      .catch((error) => {
        // Handle any errors
        console.error(error);
      });
  };
  
  return (
    <Box
      m="20px"
      sx={{
        // backgroundColor: "red",
        width: "100%",
        textAlign: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          //   backgroundColor: "yellow",
          width: "100%",
          textAlign: "center",
        }}
      >
        <Grid container spacing={0}>
          <Grid item lg={6} sm={12} md={6}>
            <Box>
              <Typography
                variant="h1"
                fontSize={40}
                fontWeight="bold"
                color="#2699fb"
                textAlign="left"
              >
                Import Data
              </Typography>
            </Box>
          </Grid>
          <Grid item lg={1} sm={0} md={0}></Grid>
        </Grid>

        <Grid container mt={5} justifyContent="center">
          <Box width="80%"> 
            <DragDropFile onImportFile={handleImportFile}/>
          </Box>
        </Grid>

        <Grid container spacing={0} mt={5}>
          <Grid item lg={6} sm={12} md={6}>
            <Box>
              <Typography
                variant="h1"
                fontSize={25}
                fontWeight="bold"
                color="#2699fb"
                textAlign="left"
              >
                File List
              </Typography>
            </Box>
          </Grid>
          <Grid item lg={1} sm={0} md={0}></Grid>
        </Grid>
        {fileListData ? (
          <Box mt={5} width="100%">
            <TableImportData
              rows={fileListData}
              columns={columns}
              totalPage={fileListData.last_page_number}
              handleDownload={handleDownload}
              loading={loadingTable}
            />
          </Box>
        ) : (
          <p>No data available</p>
        )}
      </Box>
    </Box>
    // </ThemeProvider>
  );
};

export default FileImport;
